var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 39,
    viewBox: "0 0 47 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7896 0.520733C21.9542 0.355668 22.1498 0.224707 22.3652 0.135351C22.5805 0.0459954 22.8114 0 23.0445 0C23.2776 0 23.5085 0.0459954 23.7238 0.135351C23.9392 0.224707 24.1348 0.355668 24.2994 0.520733L45.5692 21.7905C45.902 22.1233 46.089 22.5747 46.089 23.0454C46.089 23.5161 45.902 23.9675 45.5692 24.3003C45.2364 24.6332 44.785 24.8201 44.3143 24.8201C43.8436 24.8201 43.3922 24.6332 43.0594 24.3003L23.0445 4.28194L3.02964 24.3003C2.69681 24.6332 2.24541 24.8201 1.77472 24.8201C1.30404 24.8201 0.852628 24.6332 0.519804 24.3003C0.186979 23.9675 0 23.5161 0 23.0454C0 22.5747 0.186979 22.1233 0.519804 21.7905L21.7896 0.520733V0.520733Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7896 14.7006C21.9542 14.5355 22.1498 14.4046 22.3652 14.3152C22.5805 14.2259 22.8114 14.1799 23.0445 14.1799C23.2776 14.1799 23.5085 14.2259 23.7238 14.3152C23.9392 14.4046 24.1348 14.5355 24.2994 14.7006L45.5692 35.9704C45.902 36.3032 46.089 36.7546 46.089 37.2253C46.089 37.696 45.902 38.1474 45.5692 38.4802C45.2364 38.813 44.785 39 44.3143 39C43.8436 39 43.3922 38.813 43.0594 38.4802L23.0445 18.4618L3.02964 38.4802C2.69681 38.813 2.24541 39 1.77472 39C1.30404 39 0.852628 38.813 0.519804 38.4802C0.186979 38.1474 1.1631e-08 37.696 0 37.2253C-1.1631e-08 36.7546 0.186979 36.3032 0.519804 35.9704L21.7896 14.7006V14.7006Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChev);
export default __webpack_public_path__ + "static/media/chev.e1222feeeec29ecf8de47bd722bd1b0f.svg";
export { ForwardRef as ReactComponent };